import React from 'react'
import PropTypes from 'prop-types'
import { Breadcrumb as BreadcrumbStrap } from 'reactstrap'
import { BreadcrumbItem } from 'components/qstrap'

const propTypes = {
  paths: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentPageName: PropTypes.string,
  className: PropTypes.string,
}

export const Breadcrumb = ({ paths, currentPageName, className }) => (
  <BreadcrumbStrap className={className}>
    {paths.map((path, num) =>
      <BreadcrumbItem key={num} tag="a" href={path.url}>{path.name}</BreadcrumbItem>)}
    <BreadcrumbItem tag="span">{currentPageName}</BreadcrumbItem>
  </BreadcrumbStrap>
)

Breadcrumb.propTypes = propTypes

Breadcrumb.defaultProps = {
  currentPageName: '',
}
